import { pick } from 'lodash';
import { Service } from '@redshelf/redshelf-data';
import { Account } from '@redshelf/redshelf-data';

const environment = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV;

const accountService = new Account();
export default class TermService extends Service {
  constructor(...args) {
    super(...args);
    this.currentUser = accountService.user;
    this.lookupKey = `${environment}_${this.currentUser?.id ?? ''}_${
      this.currentUser?.whitelabel_id ?? 'rs'
    }_selectedTerm`;
    this.selectedTerm = JSON.parse(localStorage.getItem(this.lookupKey)) || '';
  }

  setSelectedTerm(term) {
    const selectedTerm = pick(term, ['id', 'name']);
    localStorage.setItem(this.lookupKey, JSON.stringify(selectedTerm));
    this.selectedTerm = selectedTerm;
  }
}
